import * as types from './index';

export const cancelReasonsMasterListAction = (data) => { 
    return {
    type: types.CANCEL_REASONS_MASTER_LIST,
    data
    }
};

export const cancelReasonsMasterAddAction = (data) => {
    return {
    type: types.CANCEL_REASONS_MASTER_ADD,
    data
    }
};

export const cancelReasonsMasterLoadAction = (data) => {
    return {
    type: types.CANCEL_REASONS_MASTER_LOAD,
    data
    }
};

export const cancelReasonsMasterModifyAction = (data) => {
    return {
    type: types.CANCEL_REASONS_MASTER_MODIFY,
    data
    }
};

export const cancelReasonsMasterDeleteAction = (data) => {
    return {
    type: types.CANCEL_REASONS_MASTER_DELETE,
    data
    }
};

export const cancelReasonsListAction = (data) => { 
    return {
    type: types.CANCEL_REASONS_LIST,
    data
    }
};

export const cancelReasonsAddAction = (data) => {
    return {
    type: types.CANCEL_REASONS_ADD,
    data
    }
};

export const cancelReasonsLoadAction = (data) => {
    return {
    type: types.CANCEL_REASONS_LOAD,
    data
    }
};

export const cancelReasonsModifyAction = (data) => {
    return {
    type: types.CANCEL_REASONS_MODIFY,
    data
    }
};

export const cancelReasonsDeleteAction = (data) => {
    return {
    type: types.CANCEL_REASONS_DELETE,
    data
    }
};
